<h1 class="center">
  Bienvenue sur votre espace client
</h1>

<mat-grid-list class="home-page-grid" [cols]="breakpoint" rowHeight="1.35:1" *ngIf="menuItems" gutterSize="20px"
  (window:resize)="onResize($event.target.innerWidth)">
  <mat-grid-tile *ngFor="let menuItem of menuItems" [id]="menuItem.id" [ngClass]="getClickClass(menuItem)">
    <mat-grid-tile-header *ngIf="menuItem.nbNotif > 0" matTooltip="Commandes en cours" matTooltipPosition="right">
      <mat-badge [matBadge]="menuItem.nbNotif" matBadgeSize="large" class="badge-white"></mat-badge>
    </mat-grid-tile-header>
    <mat-grid-tile-header class="notif" *ngIf="showNotifDeliveryToSend(menuItem)" [ngClass]="menuItem.nbNotif > 0 ? '' : 'full'">
      <div><mat-icon>warning</mat-icon></div>
      <div>Pensez à transmettre votre commande pour la livraison du {{dateLivraison}}</div>
    </mat-grid-tile-header>
    <a [routerLink]="menuItem.link" [ngClass]="getDisabledClass(menuItem)">
      <div class="tuile-img"><mat-icon class="img" [id]="menuItem.id" [svgIcon]="menuItem.id"></mat-icon></div>
      <h2 class="tuile-txt center" *ngIf="menuItem">{{menuItem.label}}</h2>
    </a>
  </mat-grid-tile>
</mat-grid-list>